import { findCrew } from '@src/main/modules/ibdp/application/find-crew.usecase';
import { IbdpRepository } from '@src/main/modules/ibdp/domain/ibdp.repository';
import { createIbdpHttpRepository } from '@src/main/modules/ibdp/infrastructure/IbdpHttpRepository';
import { mapCrewToSCOption } from '@src/main/modules/messages/ui/mailbox/model/crew-option.model';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';

export const useCrewSearch = (filter: string) => {
  const { user } = useAuth();

  const [repository, setRepository] = useState<IbdpRepository | null>(null);

  useEffect(() => {
    if (user?.token) {
      const tokenProvider = {
        getToken: async () => user.token,
      };
      const repo = createIbdpHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token]);

  const queryResult = useQuery({
    queryKey: ['crew', filter],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findCrew(repository, filter);
    },
    enabled: !!repository && filter.length >= 2,
    staleTime: 1000 * 60,
  });

  const crewOptions = useMemo(() => {
    if (!queryResult.data) return [];
    return mapCrewToSCOption(queryResult.data);
  }, [queryResult.data]);

  return {
    ...queryResult,
    crew: queryResult.data ?? [],
    crewOptions,
  };
};
